import { Matrix } from "../../maths/Matrix";
import { Pool } from "../../utils/Pool";
const className = "TranslateCmd";
export class TranslateCmd {
    static create(tx, ty) {
        var cmd = Pool.getItemByClass(className, TranslateCmd);
        cmd.tx = tx;
        cmd.ty = ty;
        return cmd;
    }
    recover() {
        Pool.recover(className, this);
    }
    run(context) {
        context.translate(this.tx, this.ty);
    }
    getBounds(assembler) {
        tempMatrix.identity();
        tempMatrix.translate(this.tx, this.ty);
        assembler.concatMatrix(tempMatrix);
    }
    get cmdID() {
        return TranslateCmd.ID;
    }
}
TranslateCmd.ID = className;
const tempMatrix = new Matrix();
